import SvgIcon from '../../common/SvgIcon/SvgIcon';
import Button from '../../common/Button/Button';
import Banner from '../../common/Banner/Banner';
import './Error.scss';

interface ErrorProps {
  fullscreen?: boolean;
}

const Error = ({ fullscreen = false }: ErrorProps) => {
  const handleRestart = () => {
    window.location.assign('/');
  };

  const banner = (
    <div className="error-banner">
      <Banner type="error" message="Something went wrong" dismissible={false} />
    </div>
  );

  const card = (
    <div className="error-page">
      <div className="alpha-logo">
        <SvgIcon iconName="AlphaIconAndLogo" width={265} height={150} />
      </div>
      <Button buttonStyleType="primary" label="Restart" handleClick={handleRestart} />
    </div>
  );

  if (fullscreen) {
    return (
      <div className="error-screen fullscreen">
        {banner}
        <div className="error-card">{card}</div>
      </div>
    );
  }

  return (
    <>
      {banner}
      {card}
    </>
  );
};

export default Error;
